"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _decimal = require("decimal.js");

/**
 * @class
 * @classdesc Classe per tutte le funzionalita estensive di calcolazione.<br/>
 * Per Evitare problemi di calcoli usare questa classe per tutti i calcoli.<br/>
 * ATTENTION! This is a SINGLETON CLASS so it should be accessed as common.ArmDecimal.[methodName]
 * @constructor
 */
function ArmDecimal() {}
/**
 * @param {Number} int1 first number in the equation
 * @param {Number} int2 second number in the equation
 * @returns {Number} The sum of the two numbers
 */


ArmDecimal.prototype.add = function (int1, int2) {
  if (!int1) {
    int1 = 0;
  }

  if (!int2) {
    int2 = 0;
  }

  var ret = _decimal.default.add(int1, int2);

  return ret.toNumber();
};
/**
 * @param {Number} int1 first number in the equation
 * @param {Number} int2 second number in the equation
 * @returns {Number} The subtraction of the two numbers
 */


ArmDecimal.prototype.sub = function (int1, int2) {
  if (!int1) {
    int1 = 0;
  }

  if (!int2) {
    int2 = 0;
  }

  var ret = _decimal.default.sub(int1, int2);

  return ret.toNumber();
};
/**
 * @param {Number} int1 first number in the equation
 * @param {Number} int2 second number in the equation
 * @returns {Number} Division of the two numbers passed
 */


ArmDecimal.prototype.div = function (int1, int2) {
  if (!int1) {
    int1 = 0;
  }

  if (!int2) {
    int2 = 0;
  }

  var ret = _decimal.default.div(int1, int2);

  return ret.toNumber();
};
/**
 * @param {Number} int1 first number in the equation
 * @param {Number} int2 second number in the equation
 * @returns {Number} Multiplication of the two numbers
 */


ArmDecimal.prototype.mul = function (int1, int2) {
  if (!int1) {
    int1 = 0;
  }

  if (!int2) {
    int2 = 0;
  }

  var ret = _decimal.default.mul(int1, int2);

  return ret.toNumber();
};
/**
 * For all the roundings are made with ROUND_HALF_UP mode
 * @param {Number} int The number in input
 * @param {Number} scale The scale that should be considered for the rounding
 * @returns {Number} The value of the rounded number based on the scale Ritorna il valore del numero arrotondato in base al 'roundingInteger'
 */


ArmDecimal.prototype.round = function (int, scale) {
  if (!int) {
    int = 0;
  }

  var decimal = new _decimal.default(int);
  var ret = decimal.toDecimalPlaces(scale, _decimal.default.ROUND_HALF_UP);
  return ret.toNumber();
};
/**
 * Fa il compare dei due numeri 
 * @param {Number} int1 first number in the equation
 * @param {Number} int2 second number in the equation
 * @returns {Number} Se il resultato e' :<br/>
 *      1) res < 0 allora int1 < int2;<br/>
 *      2) res = 0 allora int1 = int2;<br/>
 *      3) res > 0 allora int1 > int2;
 */


ArmDecimal.prototype.compare = function (int1, int2) {
  if (!int1) {
    int1 = 0;
  }

  if (!int2) {
    int2 = 0;
  }

  var decimal1 = new _decimal.default(int1);
  var decimal2 = new _decimal.default(int2);
  var ret = decimal1.comparedTo(decimal2);
  return ret;
};

var exp = new ArmDecimal();
var _default = exp;
exports.default = _default;